var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAllShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7032 18.9931H4.29696C2.48246 18.9931 1.00696 17.5322 1.00696 15.7363V9.70212C1.00696 9.17382 1.43566 8.74512 1.96396 8.74512C2.49226 8.74512 2.92096 9.17382 2.92096 9.70212V15.7363C2.92096 16.4765 3.53816 17.0791 4.29696 17.0791H15.7032C16.462 17.0791 17.0792 16.4766 17.0792 15.7363V9.70212C17.0792 9.17382 17.5079 8.74512 18.0362 8.74512C18.5645 8.74512 18.9932 9.17382 18.9932 9.70212V15.7363C18.9932 17.5322 17.5176 18.9931 15.7032 18.9931Z",
    fill: "#919299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 6.23342C13.0899 6.23342 12.8468 6.14062 12.6612 5.95512L10.0001 3.29402L7.33904 5.95512C6.96794 6.32622 6.36634 6.32622 5.99524 5.95512C5.62414 5.58402 5.62414 4.98242 5.99524 4.61133L9.32824 1.27833C9.69934 0.907225 10.3009 0.907225 10.672 1.27833L14.005 4.61133C14.3761 4.98242 14.3761 5.58402 14.005 5.95512C13.8195 6.14062 13.5763 6.23342 13.3331 6.23342Z",
    fill: "#919299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.7334C9.47573 13.7334 9.04993 13.3076 9.04993 12.7832V1.9502C9.04993 1.4258 9.47573 1 10.0001 1C10.5245 1 10.9503 1.4258 10.9503 1.9502V12.7832C10.9503 13.3076 10.5245 13.7334 10.0001 13.7334Z",
    fill: "#919299"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAllShare);
export default __webpack_public_path__ + "static/media/ic_all_share.939b354ba042301c6f968e85ca0f25fb.svg";
export { ForwardRef as ReactComponent };